import type { SharedEnvironment } from "./types.ts";

type ClientEnv = Pick<
  SharedEnvironment,
  "SUPABASE_URL" | "SUPABASE_ANON_KEY"
> & {
  SENTRY_DSN?: string | undefined;
};

const readRequired = (key: keyof ImportMetaEnv): string => {
  const value = import.meta.env[key];
  if (typeof value === "string" && value.length > 0) {
    return value;
  }
  throw new Error(`Missing required client environment variable ${key}`);
};

const readOptional = (key: keyof ImportMetaEnv): string | undefined => {
  const value = import.meta.env[key];
  if (typeof value === "string" && value.length > 0) {
    return value;
  }
  return undefined;
};

export const clientEnv: ClientEnv = {
  SUPABASE_URL: readRequired("SUPABASE_URL"),
  SUPABASE_ANON_KEY: readRequired("SUPABASE_ANON_KEY"),
  SENTRY_DSN: readOptional("SENTRY_DSN"),
};
